export const environment = {
  name: 'testing',
  backendMode: 'development',
  rootDomain: 'test.fan-at.dev',
  projectType: 'website',
  prodMode: true,
};
